<template>
    <div class="meeting-list">
        <div class="list-tittle">
            <div class="tittle-left">
                <span class="list" >已结案件</span>
            </div>
            <div class="tittle-right">
                <span class="status-select">
                    <span>案件类型</span>
                    <el-select v-model="meetingType" placeholder="请选择案件类型" @change="seachList">
                        <el-option
                                v-for="item in typeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </span>

                <span class="status-select">
                    <el-input v-model="keyWords" placeholder="搜索申请人/被申请人/案号" clearable style="width: 240px" @change="seachList" @clear="seachList"></el-input>
                </span>
                <span @click="seachList()" class="search-list">搜索</span>
            </div>
        </div>
        <div class="content">
            <div class="item_body">
                <el-table :data="caseList" cell-class-name = "cell-name" header-cell-class-name = 'cell-name' style="width: 100%">
                    <el-table-column prop="mediationMeetingType" label="案件类型" width="160px"></el-table-column>
                    <el-table-column prop="caseNo" label="案号/会议主题"></el-table-column>
                    <el-table-column prop="applicantName" label="申请人"></el-table-column>
                    <el-table-column prop="orderTime" :formatter="formatDate" label="庭审时间"></el-table-column>
                    <el-table-column prop="endTime" :formatter="formatEndDate" label="结案时间"></el-table-column>
                    <el-table-column min-width ='110' label="操作">
                        <template slot-scope="scope">
                            <template v-if="scope.row.mediationMeetingTypeCode == case_type_code.MEDIATION_MEETING">
                                <el-button  class="btn-action" @click="checkDetail(scope.row)" type="text" size="small">查看详情</el-button>
                                <el-button  v-if =  "(scope.row.mediationStatus == 'RUNNING' || scope.row.mediationStatus == 'END')"  class="btn-action" @click="openvideodialog(scope.row.id)" type="text" size="small">视频记录</el-button>
                                <el-button v-if =  "scope.row.mediationStatus == 'RUNNING'"  class="btn-action" @click="enterVedio(scope.row)" type="text" size="small">进入视频</el-button>
                            </template>
                            <template v-else>
                                <el-button  class="btn-action" @click="enterCaseDetail(scope.row, true)" type="text" size="small">{{ scope.row.mediationMeetingType }}</el-button>
                            </template>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="page-box" v-if= 'totalData'>
            <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="totalData"
                    :current-page.sync="curIndex"
                    :page-size="pageSize"
                    @current-change="changepage"
                    prev-text="上一页"
                    next-text="下一页">
            </el-pagination>
        </div>
        <video-record ref="comVideoRecord"></video-record>
    </div>
</template>
<script>
    import videoRecord from '@/components/videoRecord'
    import {ERR_OK} from '@/api/reConfig'
    import { setStore, getUrlParams, getStore } from '@/utils/utils.js'
    import { caseListMixins } from "./caseListMixins";
    import {newCaseList} from "../../api/case";

    export default {
        data() {
            return {
                curIndex:1,
                pageSize:10,
                totalData:0,
                meetingType:"",
                caseList: [],
                keyWords: '',
                cancelFlag : false,
                currentLoginUserId: null,
                videoMeeting: 1,
                caseId: null,
            }
        },
        mixins: [caseListMixins],
        created() {
            if(getUrlParams().appName){
                setStore('appName', getUrlParams().appName);
            }
        },
        components:{
            videoRecord,
        },
        mounted() {
            this.videoMeeting = getUrlParams().videoMeeting ? getUrlParams().videoMeeting : this.videoMeeting
            this.caseId = getUrlParams().caseId ? getUrlParams().caseId : this.caseId
            if(getUrlParams().token) {
                setStore('isOutter', 1);
                setStore('flk', getUrlParams().token);
                document.querySelector('.el-header').style.display = 'none'
                document.querySelector('.el-aside').style.display = 'none'
            }
            this.seachList()
        },
        methods: {
            seachList(page){
                !page&&(this.curIndex=1)
                let params = {
                    mediationMeetingType: this.meetingType? this.meetingType: null ,
                    keyword: this.keyWords? this.keyWords: null,
                    meetingType:this.meetingType ,
                    pageIndex:this.curIndex,
                    pageSize:this.pageSize,
                    isEnd: true
                }
                newCaseList(params).then(res =>{
                    if(res.data.code == ERR_OK){
                        let tempDataList = [],dataList = res.data.data
                        if(dataList.list && dataList.list.length>0){
                            dataList.list.forEach(element => {
                                let mtimeFlag
                                if (!element.orderTime) { return; }
                                let minutesPlus = (element.orderTime - new Date().getTime())/60000
                                if(minutesPlus>30){
                                    mtimeFlag = true
                                } else{
                                    mtimeFlag = false
                                }
                                let options = {
                                    creatorId: element.creatorId,
                                    caseId: element.caseId,
                                    id: element.id,
                                    mediationStatus: element.mediationStatus,
                                    meetingType: element.meetingType,
                                    meetingTypeName: element.meetingTypeName,
                                    name: element.name,
                                    orderTime: element.orderTime,
                                    orgId: element.orgId,
                                    orgName: element.orgName,
                                    roomId: element.roomId,
                                    startTime:element.startTime,
                                    cancelFlag:mtimeFlag,
                                    applicantName: element.applicantName,
                                    caseNo: element.caseNo,
                                    clerk: element.clerk,
                                    endTime: element.endTime,
                                    mediationMeetingType:  element.mediationMeetingType,
                                    mediationMeetingTypeCode:  element.mediationMeetingTypeCode,
                                    mediator: element.mediator,
                                }
                                tempDataList.push(options)
                            })
                        }
                        this.caseList = tempDataList
                        this.totalData = dataList.totalRows
                    }
                },erro => {
                    console.log(erro)
                })
            },
            openvideodialog(meetingid) {
                this.$refs.comVideoRecord.openDialog( meetingid)
            },
            changepage(value) {
                this.curIndex = value
                this.seachList(1)
            }
        }
    }
</script>
<style lang="scss">
    .el-message-box__wrapper{
        .el-message-box.book_quit{
            width: 440px;
            text-align: center;
            position: relative;
            .el-message-box__header{
                border-bottom: 1px solid #e5e5e5;
                padding: 20px 35px 10px;
                font-size: 16px;
                color:#666;
                text-align: left;
                padding-left: 40px;
                &:before {
                    content: '';
                    position: absolute;
                    display: inline-block;
                    left: 26px;
                    top: 18px;
                    width: 4px;
                    height: 20px;
                    background: #0083c8;
                }
            }
            .el-message-box__btns{
                text-align: center;
                .book_button_primary_small{
                    color:  #fff;
                    margin-left: 30px;
                }
                .book_button_default_small {
                    background: #fff;
                    color:  #0083c8;
                }
                .el-button {
                    width: 150px;
                    height: 50px;
                }
            }
            // .el-message-box__content{
            //     padding: 60px 0 50px 0;
            //     font-size: 16px;

            // }
        }
    }
    .meeting-list {
        .list-tittle {
            width: 100%;
            height: 60px;
            background: #fff;
            overflow: hidden;
            line-height: 60px;
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;
            .tittle-left{
                .lauch-list {
                    cursor: pointer;
                    font-size: 14px;
                    display: inline-block;
                    border-radius: 4px;
                    margin-left: 20px;
                    width: 80px;
                    height: 30px;
                    line-height: 30px;
                    border: 1px solid #0083c8;
                    color:#0083c8;
                    text-align: center;
                    &:hover{
                        color: #fff;
                        background: #0083c8;
                    }
                }
                margin-left: 20px;
                font-size: 16px;
                color: #333333;
                .list {
                    display: inline-block;
                    margin-right: 20px;
                }
                .el-button {
                    height: 30px;
                    width: 96px;
                    line-height: 5px;
                    border-radius: 4px;
                    border: solid 1px #0083c8;
                    color: #0083c8;
                    &:hover{
                        color: #fff;
                        background: #0083c8;
                    }
                }

            }
            .tittle-right {
                display: flex;
                margin-right: 20px;
                .status-select {
                    display: flex;
                    margin-left: 20px;
                    span {
                        font-size: 15px;
                        color: #606266;
                        margin-right: 10px;
                    }
                }
                .search-list{
                    cursor: pointer;
                    font-size: 14px;
                    display: inline-block;
                    border-radius: 4px;
                    margin-left: 20px;
                    width: 80px;
                    height: 30px;
                    margin-top: 14px;
                    line-height: 30px;
                    border: 1px solid #0083c8;
                    color:#0083c8;
                    text-align: center;
                    &:hover{
                        color: #fff;
                        background: #0083c8;
                    }
                }
            }
        }
        .item_body {
            margin-top: 10px;
            .cell-name {
                text-align: center;
            }
            .btn-action {
                font-size: 14px;
            }

        }
        .page-box {
            background: #fff;
            text-align: center;
            padding: 40px 0 40px;
            li {
                padding: 0;
                border: none;
            }
        }

    }

</style>
